import React, { useContext, useState, useEffect } from 'react';

import Api from '../../api';

import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import JobList from '../../components/JobList';
import Context from '../../providers/Context';
import JobLoading from '../../components/JobLoading';

const OfertasPage = props => {
	const { jobs, dispatch } = useContext(Context);
	const [loading, setLoading] = useState(false);

	const fetchJobs = async () => {
		setLoading(true);

		const clients = {
			client_id: process.env.REACT_APP_CLIENT_ID,
		};

		await Api()
			.post('/get_oferts', { ...clients })
			.then(res => {
				dispatch({ type: `FETCH_JOBS`, payload: [...res.data.data] });
			});
		setLoading(false);
	};

	useEffect(() => {
		fetchJobs();
	}, []);

	return (
		<Layout page='ofertas'>
			<SEO title='Ofertas' />
			<div className='w-full text-telus-dark pt-32'>
				<div className='container mx-auto w-full p-8'>
					<section className='flex flex-col' id='jobs'>
						<strong className='text-telus-dark block lg:hidden py-4'>
							Consulta aquí nuestras oportunidades laborales activas o dejamos
							tu información:
						</strong>
						<div className='flex flex-row bg-ccu-green text-telus-dark rounded-lg py-3 px-6 my-8 hidden lg:flex'>
							<div className='flex-1'>
								<strong>Nombre del Cargo</strong>
							</div>
							<div className='flex-1 hidden lg:block'>
								<strong>Fecha de Publicación</strong>
							</div>
							<div className='flex-1 hidden lg:block'>
								<strong>Fecha de Término</strong>
							</div>
						</div>
						{loading && loading === true ? (
							<JobLoading />
						) : (
							<JobList
								jobs={
									jobs !== undefined
										? jobs.filter(ofert => ofert.is_show === true)
										: []
								}
							/>
						)}
					</section>
					{jobs !== undefined &&
					jobs.filter(ofert => ofert.is_show === false) &&
					jobs.filter(ofert => ofert.is_show === false).length === 1 ? (
						<section
							className='flex flex-col py-10 justify-center items-center'
							id='general_postulation'
						>
							<div className='bg-telus-purple rounded-full py-2 px-4 text-center lg:px-20'>
								<a
									className='w-full font-bold text-white'
									href={`${process.env.REACT_APP_CLIENT_URL}${
										jobs.filter(ofert => ofert.is_show === false)[0].slug
									}/postular`}
									rel='noopener noreferrer'
									target='_blank'
								>
									Si no encuentras una oferta, déjanos tus datos y te
									contactaremos
								</a>
							</div>
						</section>
					) : (
						[]
					)}
				</div>
			</div>
		</Layout>
	);
};

export default OfertasPage;
